import { Tab } from 'react-aria-components';
import { VisuallyHidden } from 'react-aria';

// Can be used within React Aria based tab menus to hide a tab from the user while still keeping it the tab states
// constistent, and the content
export const HiddenTab = (props: {
  children: React.ReactNode;
  id: React.ComponentProps<typeof Tab>['id'];
  isDisabled?: boolean;
}) => {
  return (
    // `isDisabled` is forwarded rather than dropped: a tab that is both hidden and disabled would
    // otherwise keep its place in the arrow-key order and stay selectable, so keyboard focus could
    // land on a tab nobody can see.
    <Tab key={props.id} id={props.id} isDisabled={props.isDisabled}>
      <VisuallyHidden>{props.children}</VisuallyHidden>
    </Tab>
  );
};
